<template lang="pug">
  SupplierLayout
    CommonSection.b-supplier-profile-page(title="Карточка поставщика" data-testid="supplier-profile-page")
      template(v-if="card")
        ._readonly
          ._readonly-title Заполняет администратор
          ._line
            ._label Название
            span._value(data-testid="supplier-profile-name") {{ card.name }}
          ._line
            ._label Регион
            span._value(data-testid="supplier-profile-region") {{ card.region || '—' }}
          ._line
            ._label Категории
            span._value(data-testid="supplier-profile-categories") {{ categoriesText }}
          ._line
            ._label Бренды
            span._value(data-testid="supplier-profile-brands") {{ brandsText }}

        ._contacts
          ._contacts-title Контакты — можно менять
          ._line
            ._label Адрес
            BaseInput._input(inputTestId="supplier-profile-address" v-model="form.address")
          ._line
            ._label Сайт
            BaseInput._input(inputTestId="supplier-profile-website" v-model="form.website")
          ._line
            ._label Телефон
            BaseInput._input(inputTestId="supplier-profile-phone" v-model="form.phone")
          ._line
            ._label E-mail
            BaseInput._input(inputTestId="supplier-profile-email" v-model="form.email")
          ._line
            ._label Контактное лицо
            BaseInput._input(inputTestId="supplier-profile-contact-person" v-model="form.contactPerson")
          ._buttons
            Btn(blue data-testid="supplier-profile-save" @click="save") Сохранить
</template>

<script>
import SupplierLayout from '@/layouts/Supplier.vue';
import CommonSection from '@/components/CommonSection.vue';
import BaseInput from '@/components/BaseInput.vue';
import model from '@/model/supplierCabinet';
import { categoryTitle } from '@/utils/spec';

/**
 * Карточка поставщика (ТЗ 6.5): просмотр всех полей, правка только контактов. Название, регион,
 * категории и бренды правит администратор — поставщику они показаны только для чтения, а попытка
 * их изменить отклоняется сервером (ТЗ 4.2). Сгенерировано Claude.
 */
export default {
  name: 'SupplierProfilePage',
  components: { SupplierLayout, CommonSection, BaseInput },
  data() {
    return {
      card: null,
      form: {
        address: '',
        website: '',
        phone: '',
        email: '',
        contactPerson: '',
      },
    };
  },
  computed: {
    supplierId() { return this.$store.state.auth.user?.supplier?.id ?? null; },
    categoriesText() {
      return (this.card?.categories ?? []).map(categoryTitle).join(', ') || '—';
    },
    brandsText() {
      return (this.card?.brands ?? []).join(', ') || '—';
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      if (!this.supplierId) return;
      this.card = await model.fetchProfile(this.supplierId);
      this.form = {
        address: this.card.address ?? '',
        website: this.card.website ?? '',
        phone: this.card.phone ?? '',
        email: this.card.email ?? '',
        contactPerson: this.card.contactPerson ?? '',
      };
    },
    async save() {
      const saved = await model.saveContacts(this.supplierId, {
        address: this.form.address || null,
        website: this.form.website || null,
        phone: this.form.phone || null,
        email: this.form.email || null,
        contactPerson: this.form.contactPerson || null,
      });
      if (saved) this.card = saved;
    },
  },
};
</script>

<style scoped lang="scss">
.supplier-profile-page {
  &__readonly,
  &__contacts {
    max-width: 640px;
    padding: 14px 16px;
    margin-bottom: 20px;
    border: 1px solid var(--color-super-light);
    border-radius: 8px;
    background: var(--color-white);
  }

  &__readonly-title,
  &__contacts-title {
    font-weight: 700;
    font-size: 14px;
    margin-bottom: 10px;
  }

  &__line {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
  }

  &__label {
    flex: 0 0 160px;
    font-size: 13px;
    color: var(--color-middle-gray);
  }

  &__value {
    font-size: 14px;
  }

  &__input {
    flex-grow: 1;
  }

  &__buttons {
    margin-top: 14px;
  }

  // Узкие экраны (общий порог модуля — 768 px): подпись поля встаёт над значением,
  // иначе на 160 px подписи значению не остаётся места
  @media (max-width: 768px) {
    &__line {
      flex-direction: column;
      align-items: stretch;
      gap: 4px;
    }

    &__label {
      flex: 0 0 auto;
    }
  }
}
</style>
